/* eslint-disable */
/* tslint:disable */
/* Generated by @yy/tagee-cli v0.2.11 */
import Fetcher from '@yy/fetcher'
import { GETProtocolCheck } from './req/GETProtocolCheck'
import { GETProtocolDetail } from './req/GETProtocolDetail'
import { POSTProtocolSign } from './req/POSTProtocolSign'
import { GETProtocolCheckRes } from './res/GETProtocolCheck'
import { GETProtocolDetailRes } from './res/GETProtocolDetail'
import { POSTProtocolSignRes } from './res/POSTProtocolSign'

// helper 函数
interface PlatObject {
  [k: string]: any
}
const omit = (keysToOmit: string[] = [], originalObject = {}) => {
  const clonedObject: PlatObject = { ...originalObject }
  for (const path of keysToOmit) {
    delete clonedObject[path]
  }
  return clonedObject
}

/**
 * locationPrefix 拉取信息根据 Tagee 平台的上填写的信息生成，
 * 如果不符合使用场景，有两种办法：
 * 1. 修改 Tagee 项目信息（需要修改权限)，再次生成运行同步命令
 * 2. 手动修改
 **/
let locationPrefix = '//www.yy.com/zone/microservice/guildserver'
if (
  process &&
  process.env &&
  (process.env.NODE_ENV === 'development' || process.env.mode === 'dev')
) {
  locationPrefix = '//yyzone-api-test.yy.com/zone/microservice/guildserver'
}
// 导出域名前缀, 其他文件可以利用到
export const LocationPrefix = locationPrefix

interface ApiModels {
  /**
   * 签署协议
   * Tagee接口地址：http://tagee.yy.com/#/project/110/feature-20230109-guild_protocol/interface/4209a074ebe7656586d1fd5349692581
   */
  'POST/protocol/sign': {
    req: POSTProtocolSign
    res: POSTProtocolSignRes
  }
  /**
   * 查询是否已签约
   * Tagee接口地址：http://tagee.yy.com/#/project/110/feature-20230109-guild_protocol/interface/6758d3a0b7357965c295bddc73d8bb30
   */
  'GET/protocol/check': {
    req: GETProtocolCheck
    res: GETProtocolCheckRes
  }
  /**
   * 查询最新协议版本及文案
   * Tagee接口地址：http://tagee.yy.com/#/project/110/feature-20230109-guild_protocol/interface/e5f4ab1266890305d01a04910ac27760
   */
  'GET/protocol/detail': {
    req: GETProtocolDetail
    res: GETProtocolDetailRes
  }
}

const getFetchers = (fetcher: Fetcher) => {
  return {
    /**
     * 签署协议
     * Tagee接口地址：http://tagee.yy.com/#/project/110/feature-20230109-guild_protocol/interface/4209a074ebe7656586d1fd5349692581
     */
    'POST/protocol/sign': (req?: ApiModels['POST/protocol/sign']['req']) => {
      return fetcher.post(locationPrefix + '/protocol/sign', req) as Promise<
        ApiModels['POST/protocol/sign']['res']
      >
    },
    /**
     * 查询是否已签约
     * Tagee接口地址：http://tagee.yy.com/#/project/110/feature-20230109-guild_protocol/interface/6758d3a0b7357965c295bddc73d8bb30
     */
    'GET/protocol/check': (req?: ApiModels['GET/protocol/check']['req']) => {
      return fetcher.get(locationPrefix + '/protocol/check', req) as Promise<
        ApiModels['GET/protocol/check']['res']
      >
    },
    /**
     * 查询最新协议版本及文案
     * Tagee接口地址：http://tagee.yy.com/#/project/110/feature-20230109-guild_protocol/interface/e5f4ab1266890305d01a04910ac27760
     */
    'GET/protocol/detail': (req?: ApiModels['GET/protocol/detail']['req']) => {
      return fetcher.get(locationPrefix + '/protocol/detail', req) as Promise<
        ApiModels['GET/protocol/detail']['res']
      >
    }
  }
}

export default getFetchers
